import { render, staticRenderFns } from "./ToolsPage.vue?vue&type=template&id=871280ea&lang=pug&"
import script from "./ToolsPage.vue?vue&type=script&lang=ts&"
export * from "./ToolsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports